// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DelegateGroupedNounBRImageVoteTable_wrapper__2U2Kv","nounbrCell":"DelegateGroupedNounBRImageVoteTable_nounbrCell__v05Mx"};